module.exports = __webpack_public_path__ + "static/media/cert_20200201.26ae1446.jpg";